import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import Link from 'next/link'

const contentful = require('contentful')

const client = contentful.createClient({
  space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_KEY,
})

const convertBlogData = (listEntries) => {
  return listEntries.map((entry) => {
    return {
      id: entry.sys.id,
      ...entry.fields,
    }
  })
}

const getAllBlogData = async () => {
  return client.getEntries()
}

const getBlogEntryById = async (id) => {
  return client.getEntry(id)
}

const createInternalBlogLink = (post, locale, sitemap = false) => {
  if (sitemap) {
    return `${locale}/blog/${post.id}/${post.slug}/`
  }
  return `/${locale}/blog/${post.id}/${post.slug}/`
}

const renderDataToComponent = (data) => {
  const renderOptions = {
    renderNode: {
      [INLINES.EMBEDDED_ENTRY]: (node, children) => {
        // target the contentType of the EMBEDDED_ENTRY to display as you need
        if (node.data.target.sys.contentType.sys.id === 'blogPost') {
          return (
            <Link href={`/blog/${node.data.target.fields.slug}`}>
              {node.data.target.fields.title}
            </Link>
          )
        }
      },
      [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
        // target the contentType of the EMBEDDED_ENTRY to display as you need
        if (node.data.target.sys.contentType.sys.id === 'codeBlock') {
          return (
            <pre>
              <code>{node.data.target.fields.code}</code>
            </pre>
          )
        }

        if (node.data.target.sys.contentType.sys.id === 'videoEmbed') {
          return (
            <iframe
              src={node.data.target.fields.embedUrl}
              height="100%"
              width="100%"
              frameBorder="0"
              scrolling="no"
              title={node.data.target.fields.title}
              allowFullScreen={true}
            />
          )
        }
      },

      [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
        // render the EMBEDDED_ASSET as you need
        return (
          <img
            src={`https://${node.data.target.fields.file.url}`}
            height={node.data.target.fields.file.details.image.height}
            width={node.data.target.fields.file.details.image.width}
            alt={node.data.target.fields.description}
          />
        )
      },
    },
  }

  return documentToReactComponents(data, renderOptions)
}

module.exports = {
  convertBlogData,
  getAllBlogData,
  getBlogEntryById,
  createInternalBlogLink,
  renderDataToComponent,
}
